import React, { useState, useRef } from 'react'
import {
  Table, TableHead, TableBody, TableRow, TableCell,
  TextField, IconButton
} from '@material-ui/core'
import { Delete as DeleteIcon, Add as AddIcon } from '@material-ui/icons'
import axios from 'axios'

const AreaBreakdownTable = ({ projectService, url, onUpdate }) => {
  const [newArea, setNewArea] = useState({ label: '', quantity: '', unit: projectService.unit || '', notes: '' })
  const debounceRef = useRef(null)

  const recalc = () => axios.post(`${url}/api/bid-estimation/project-services/${projectService._id}/recalculate`).catch(() => {})

  const handleAreaFieldChange = (areaId, field, value) => {
    if (debounceRef.current) clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(async () => {
      try {
        await axios.put(`${url}/api/bid-estimation/project-services/${projectService._id}/areas/${areaId}`, { [field]: value })
        if (field === 'quantity') await recalc()
        onUpdate()
      } catch (e) {
        console.error('Area update failed:', e)
      }
    }, 600)
  }

  const handleAddArea = async () => {
    if (!newArea.label || !newArea.quantity) return
    try {
      await axios.post(`${url}/api/bid-estimation/project-services/${projectService._id}/add-area`, {
        ...newArea,
        quantity: Number(newArea.quantity)
      })
      setNewArea({ label: '', quantity: '', unit: projectService.unit || '', notes: '' })
      await recalc()
      onUpdate()
    } catch (e) {
      console.error('Add area failed:', e)
    }
  }

  const handleDeleteArea = async (areaId) => {
    try {
      await axios.delete(`${url}/api/bid-estimation/project-services/${projectService._id}/areas/${areaId}`)
      await recalc()
      onUpdate()
    } catch (e) {
      console.error('Delete area failed:', e)
    }
  }

  const areas = projectService.areas || []

  return (
    <div style={{ borderTop: '1px solid #eee' }}>
      <Table size="small">
        <TableHead>
          <TableRow style={{ background: '#f5f5f5' }}>
            <TableCell style={{ fontSize: 10, textTransform: 'uppercase', color: '#666' }}>Area</TableCell>
            <TableCell style={{ fontSize: 10, textTransform: 'uppercase', color: '#666' }}>Building</TableCell>
            <TableCell align="right" style={{ fontSize: 10, textTransform: 'uppercase', color: '#666' }}>Qty</TableCell>
            <TableCell style={{ fontSize: 10, textTransform: 'uppercase', color: '#666' }}>Unit</TableCell>
            <TableCell style={{ fontSize: 10, textTransform: 'uppercase', color: '#666' }}>Notes</TableCell>
            <TableCell style={{ width: 40 }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {areas.map(area => (
            <TableRow key={area._id}>
              <TableCell>
                <TextField size="small" defaultValue={area.label || ''} variant="standard"
                  InputProps={{ disableUnderline: true, style: { fontSize: 12, fontWeight: 500 } }}
                  onBlur={(e) => handleAreaFieldChange(area._id, 'label', e.target.value)} />
              </TableCell>
              <TableCell>
                <TextField size="small" defaultValue={area.building || ''} variant="standard"
                  InputProps={{ disableUnderline: true, style: { fontSize: 12 } }}
                  onBlur={(e) => handleAreaFieldChange(area._id, 'building', e.target.value)} />
              </TableCell>
              <TableCell align="right">
                <TextField size="small" defaultValue={area.quantity || ''} variant="standard" type="number"
                  InputProps={{ disableUnderline: true, style: { fontSize: 12, fontWeight: 600, textAlign: 'right' } }}
                  onBlur={(e) => handleAreaFieldChange(area._id, 'quantity', Number(e.target.value))} />
              </TableCell>
              <TableCell>
                <TextField size="small" defaultValue={area.unit || ''} variant="standard"
                  InputProps={{ disableUnderline: true, style: { fontSize: 12 } }}
                  onBlur={(e) => handleAreaFieldChange(area._id, 'unit', e.target.value)} />
              </TableCell>
              <TableCell>
                <TextField size="small" defaultValue={area.notes || ''} variant="standard" fullWidth
                  InputProps={{ disableUnderline: true, style: { fontSize: 11, color: '#888', fontStyle: 'italic' } }}
                  onBlur={(e) => handleAreaFieldChange(area._id, 'notes', e.target.value)} />
              </TableCell>
              <TableCell>
                <IconButton size="small" onClick={() => handleDeleteArea(area._id)}>
                  <DeleteIcon fontSize="small" style={{ color: '#ccc' }} />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
          {/* Add row */}
          <TableRow>
            <TableCell>
              <TextField size="small" placeholder="Area name" variant="standard" value={newArea.label}
                onChange={(e) => setNewArea(prev => ({ ...prev, label: e.target.value }))}
                InputProps={{ disableUnderline: true, style: { fontSize: 12 } }} />
            </TableCell>
            <TableCell />
            <TableCell align="right">
              <TextField size="small" placeholder="Qty" variant="standard" type="number" value={newArea.quantity}
                onChange={(e) => setNewArea(prev => ({ ...prev, quantity: e.target.value }))}
                InputProps={{ disableUnderline: true, style: { fontSize: 12, textAlign: 'right' } }} />
            </TableCell>
            <TableCell>
              <TextField size="small" placeholder="Unit" variant="standard" value={newArea.unit}
                onChange={(e) => setNewArea(prev => ({ ...prev, unit: e.target.value }))}
                InputProps={{ disableUnderline: true, style: { fontSize: 12 } }} />
            </TableCell>
            <TableCell>
              <TextField size="small" placeholder="Notes" variant="standard" value={newArea.notes}
                onChange={(e) => setNewArea(prev => ({ ...prev, notes: e.target.value }))}
                InputProps={{ disableUnderline: true, style: { fontSize: 11 } }} />
            </TableCell>
            <TableCell>
              <IconButton size="small" onClick={handleAddArea} disabled={!newArea.label || !newArea.quantity}>
                <AddIcon fontSize="small" style={{ color: '#4caf50' }} />
              </IconButton>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  )
}

export default AreaBreakdownTable
